module.exports = __webpack_public_path__ + "static/etiqa-maybank-b8d596747d537f20a8d096b2922d9d9d.svg";